// @generated-imports
import { escapeHTML } from './app.js';
import { dom } from './core.js';
import { GP_AXIS_DEADZONE, gpConfirmCancel, gpPressed, gpShortName } from './gamepad.js';
import { layerClosed, layerOpened } from './layers.js';
import { connectedPads } from './multiplayer.js';
// @generated-imports
/* ===========================================================================
   TESTE DO CONTROLE (v2.1)
   ---------------------------------------------------------------------------
   Mostra cada controle conectado, o layout inferido (Xbox × Nintendo, que
   decide quem é "confirmar"), os botões apertados em tempo real e os eixos
   com a zona morta. Responde a "por que o B está trocado?" e ajuda com
   controles Bluetooth que dormem ou chegam sem mapeamento padrão.
   Fechar: Esc, botão ✕ ou segurar B/○ por 1 s (o B isolado é testável).
   ======================================================================== */

const PAD_BUTTON_LABELS = ['A', 'B', 'X', 'Y', 'LB', 'RB', 'LT', 'RT', 'Select', 'Start', 'L3', 'R3', '↑', '↓', '←', '→', 'Home'];

let padTestFrame = 0;
let padTestCancelSince = 0;

function describePadLayout(pad) {
  const { confirm } = gpConfirmCancel(pad);
  return confirm === 1 ? 'Nintendo (confirma com o botão da direita)' : 'Xbox/PlayStation (confirma com o botão de baixo)';
}

function renderPadTest() {
  if (!dom.padTestList) return;
  const pads = connectedPads();
  if (!pads.length) {
    dom.padTestList.innerHTML = '<div class="backup-row">Nenhum controle detectado. Conecte o controle e aperte qualquer botão — o navegador só mostra o controle depois do primeiro botão.</div>';
    return;
  }
  dom.padTestList.innerHTML = pads.map((pad) => {
    const buttons = pad.buttons.map((b, i) => {
      const on = b && (b.pressed || b.value > 0.5);
      const label = pad.mapping === 'standard' ? (PAD_BUTTON_LABELS[i] || `B${i}`) : `B${i}`;
      return `<span class="pad-key${on ? ' is-on' : ''}" title="botão ${i}">${escapeHTML(label)}</span>`;
    }).join('');
    const axes = pad.axes.map((value, i) => {
      const pct = Math.round(((Math.max(-1, Math.min(1, value)) + 1) / 2) * 100);
      const dead = Math.abs(value) < GP_AXIS_DEADZONE;
      return `<span class="pad-axis${dead ? '' : ' is-on'}" title="eixo ${i}: ${value.toFixed(2)}"><span class="pad-axis-dot" style="left:${pct}%"></span></span>`;
    }).join('');
    return `<div class="pad-test-card">
      <strong>🎮 ${escapeHTML(gpShortName(pad.id))}</strong>
      <small>Controle ${pad.index + 1} · ${pad.mapping === 'standard' ? 'mapeamento padrão' : 'SEM mapeamento padrão (modo de compatibilidade)'} · ${escapeHTML(describePadLayout(pad))}</small>
      <div class="pad-keys">${buttons}</div>
      <div class="pad-axes">${axes}</div>
    </div>`;
  }).join('');
}

function padTestLoop() {
  padTestFrame = window.requestAnimationFrame(padTestLoop);
  renderPadTest();
  // Segurar o botão de cancelar por 1 s fecha (apertar rápido só testa).
  const holding = connectedPads().some((pad) => gpPressed(pad, gpConfirmCancel(pad).cancel));
  if (!holding) { padTestCancelSince = 0; return; }
  if (!padTestCancelSince) padTestCancelSince = Date.now();
  if (Date.now() - padTestCancelSince > 1000) closePadTest();
}

function openPadTest() {
  if (!dom.padTestModal) return;
  dom.padTestModal.classList.remove('is-hidden');
  layerOpened('pad-test', dom.padTestClose);
  window.cancelAnimationFrame(padTestFrame);
  padTestCancelSince = 0;
  padTestLoop();
}

function closePadTest() {
  window.cancelAnimationFrame(padTestFrame);
  padTestFrame = 0;
  if (!dom.padTestModal) return;
  dom.padTestModal.classList.add('is-hidden');
  layerClosed('pad-test');
}

// @generated-exports
export { PAD_BUTTON_LABELS, closePadTest, describePadLayout, openPadTest, padTestCancelSince, padTestFrame, padTestLoop, renderPadTest };
// @generated-exports
